/* CRAZY MUG — compléments : upgrade de pack dans le panier, prix unitaire sous le prix. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const rafraichir = async () => {
    const panier = $('[data-sy-panier]');
    if (!panier) return;
    const corps = $('[data-sy-corps]', panier);
    const r = await fetch(racine + '?section_id=somya-panier-contenu', { headers: { Accept: 'text/html' } });
    if (!r.ok) return;
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const neuf = $('[data-sy-contenu]', doc);
    if (neuf && corps) { corps.innerHTML = ''; corps.appendChild(neuf); const n = Number(neuf.dataset.syNombre || 0); $$('[data-sy-compteur]').forEach((el) => { el.textContent = n; el.hidden = !n; }); }
  };

  /* Passer à un pack supérieur en un clic : on retire la ligne, on ajoute la variante du pack. */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cm-upgrade]');
    if (!b) return;
    const zone = b.closest('[data-sy-panier], [data-sy-panier-page]');
    zone && zone.classList.add('est-charge');
    b.disabled = true; b.textContent = 'Un instant…';
    try {
      await fetch(racine + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.cmKey, quantity: 0 }) });
      await fetch(racine + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.cmUpgrade), quantity: 1 }] }) });
    } catch (_) {}
    if (zone && zone.hasAttribute('data-sy-panier-page')) { location.reload(); return; }
    await rafraichir();
    zone && zone.classList.remove('est-charge');
  });

  /* Prix par verre + économie sous le prix principal quand on change de pack. */
  const pp = $('[data-sy-produit]');
  if (pp) {
    const unit = $('[data-cm-unit]', pp), eco = $('[data-cm-eco]', pp), stickyTxt = $('[data-cm-sticky-pack]');
    const maj = () => {
      const c = $('[data-sy-valeur]:checked', pp);
      if (!c) return;
      if (unit) unit.innerHTML = c.dataset.cmUnitTxt || '';
      if (eco) { eco.textContent = c.dataset.cmEcoTxt || ''; eco.hidden = !c.dataset.cmEcoTxt; }
      if (stickyTxt) stickyTxt.textContent = c.value;
    };
    pp.addEventListener('change', (e) => { if (e.target.matches('[data-sy-valeur]')) maj(); });
    maj();
  }
})();
